import 'reflect-metadata';
require('../bootstrap');
import { onClick, ready } from '../../app/support/utils';
import wizard from './Wizard';

ready(() => {

    onClick('.forward', (e: Event) => {
        e.preventDefault();

        wizard.forward();
    });

    onClick('.backward', (e: Event) => {
        e.preventDefault();

        wizard.backward();
    });
});
